import { TextField } from '@src/shared/ui/fields';

type NotesFieldProps = {
  disabled?: boolean;
};

export default function NotesField({ disabled = false }: NotesFieldProps) {
  return (
    <TextField
      disabled={disabled}
      multiline
      fullWidth
      label="Notes"
      name="notes"
      rows={5}
    />
  );
}
